import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MagnifyingGlass, Bell } from "@phosphor-icons/react";
import { STATUS, StatusBadge, fmtBRL, fmtDate, fmtDateTime } from "@/lib/medicoes";

const AlertCard = ({ label, n, color, onClick, testid }) => (
  <button onClick={onClick} data-testid={testid} className="tce-card p-5 text-left hover:border-[#FFDF00]/60">
    <div className="uppercase-label !text-[10px]">{label}</div>
    <div className="font-heading text-3xl mt-2 font-mono" style={{ color }}>{n}</div>
  </button>
);

export default function MedicoesFiscalizacao() {
  const [q, setQ] = useState({ status: "", search: "" });
  const [d, setD] = useState(null);
  useEffect(() => {
    const params = Object.fromEntries(Object.entries(q).filter(([, v]) => v));
    const t = setTimeout(() => api.get("/medicoes", { params }).then((r) => setD(r.data)), 250);
    return () => clearTimeout(t);
  }, [q]);
  const a = d?.alertas || {};
  return (
    <div className="space-y-6" data-testid="medicoes-fiscalizacao">
      <div>
        <div className="uppercase-label">Fiscalização e engenharia</div>
        <h1 className="font-heading text-4xl tracking-tight mt-2">Medições de fornecedores</h1>
        <p className="text-sm text-[#94A3B8] mt-2">Análise técnica, devolução, rejeição e aprovação das medições enviadas pelas contratadas.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <AlertCard label="Novas submetidas" n={a.novas || 0} color="#3B82F6" testid="alerta-novas" onClick={() => setQ({ ...q, status: "enviada" })} />
        <AlertCard label="Correções reenviadas" n={a.reenviadas || 0} color="#F97316" testid="alerta-reenviadas" onClick={() => setQ({ ...q, status: "enviada" })} />
        <AlertCard label="Em análise" n={a.em_analise || 0} color="#F59E0B" testid="alerta-em-analise" onClick={() => setQ({ ...q, status: "em_analise" })} />
        <AlertCard label="Aguardando aprovação final" n={a.aguardando_final || 0} color="#22C55E" testid="alerta-final" onClick={() => setQ({ ...q, status: "aprovada_fiscal" })} />
      </div>
      <div className="tce-card p-4 flex flex-wrap gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
          <input data-testid="mf-search" value={q.search} onChange={(e) => setQ({ ...q, search: e.target.value })} placeholder="Contrato, fornecedor, objeto…" className="tce-input w-full pl-10 pr-3 py-2.5 rounded-md text-sm" />
        </div>
        <select data-testid="mf-status" value={q.status} onChange={(e) => setQ({ ...q, status: e.target.value })} className="tce-input px-3 py-2.5 rounded-md text-sm">
          <option value="">Todas as situações</option>
          {Object.entries(STATUS).filter(([k]) => k !== "rascunho").map(([k, s]) => <option key={k} value={k}>{`${s.label} (${d?.contagem?.[k] || 0})`}</option>)}
        </select>
      </div>
      <div className="tce-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#1E293B] text-left"><tr>
            {["Medição", "Contrato", "Fornecedor", "Município", "Período", "Valor", "Atualizada", "Situação"].map((h) => <th key={h} className="px-4 py-3 uppercase-label !text-[10px]">{h}</th>)}
          </tr></thead>
          <tbody>
            {!d && <tr><td colSpan={8} className="px-4 py-8 text-center text-[#94A3B8]">Carregando…</td></tr>}
            {d && !d.items.length && <tr><td colSpan={8} className="px-4 py-8 text-center text-[#94A3B8]">Nenhuma medição encontrada.</td></tr>}
            {d?.items.map((m, i) => (
              <tr key={m.id} className="border-t border-[#334155] hover:bg-[#1E293B]/60" data-testid={`mf-row-${i}`}>
                <td className="px-4 py-3"><Link to={`/medicoes/${m.id}`} data-testid={`mf-link-${i}`} className="font-mono text-[#FFDF00] hover:underline">nº {m.numero} <span className="text-[#94A3B8]">v{m.versao}</span></Link>
                  {m.status === "enviada" && m.versao > 1 && <span className="ml-2 text-[10px] text-[#F97316] inline-flex items-center gap-1"><Bell size={10} /> correção</span>}</td>
                <td className="px-4 py-3 font-mono text-xs">{m.contract_numero}</td>
                <td className="px-4 py-3 text-[#94A3B8] max-w-[200px] truncate">{m.fornecedor_nome}</td>
                <td className="px-4 py-3 text-[#94A3B8]">{m.municipio_nome}</td>
                <td className="px-4 py-3 text-xs text-[#94A3B8] whitespace-nowrap">{fmtDate(m.periodo_inicio)} a {fmtDate(m.periodo_fim)}</td>
                <td className="px-4 py-3 font-mono">{fmtBRL(m.valor_total)}</td>
                <td className="px-4 py-3 text-xs text-[#94A3B8]">{fmtDateTime(m.updated_at)}</td>
                <td className="px-4 py-3"><StatusBadge status={m.status} valorPago={m.valor_pago} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
